

export class RoutePathStatusInput implements IRoutePathStatusInput {
    /** The auto-generated id of the route path master */
    routePathId!: number;
    /** The updated status */
    status!: number;

    constructor(data?: IRoutePathStatusInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.routePathId = _data["routePathId"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): RoutePathStatusInput {
        data = typeof data === 'object' ? data : {};
        let result = new RoutePathStatusInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["routePathId"] = this.routePathId;
        data["status"] = this.status;
        return data; 
    }
}

export interface IRoutePathStatusInput {
    /** The auto-generated id of the route path master */
    routePathId: number;
    /** The updated status */
    status: number;
}

